import gql from 'graphql-tag';

export default gql`
  mutation updateOneLessonTemplateMutation(
    $course: MongoID!
    $courseCategory: MongoID!
    $_id: MongoID
    $isTeacherLessonTemplate: Boolean
    $isSuperTeacherTemplate: Boolean
  ) {
    updateOneLessonTemplateMutation(
      course: $course
      courseCategory: $courseCategory
      _id: $_id
      isTeacherLessonTemplate: $isTeacherLessonTemplate
      isSuperTeacherTemplate: $isSuperTeacherTemplate
    ) {
      record {
        _id
      }
    }
  }
`;
